import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { AssistantNewForm } from "../../components/AssistantNewForm/AssistantNewForm";

const AssistantNewScreen = () => {
  return (
    <ScreenLayout>
      <AssistantNewForm />
    </ScreenLayout>
  );
};

export default AssistantNewScreen;
